import { Component, ViewChild } from '@angular/core';
import { SidebarComponent } from './sidebar/sidebar.component';
import { GeocodingService } from '../../../../../shared/services/geocoding.service';
import { MapService } from '../../../../../shared/services/map.service';
import { SensorService } from '../../../../../shared/services/sensor.service';
import { Sensor } from '../../../../../shared/models/sensor';
import { debounceTime, distinctUntilChanged, of, switchMap } from 'rxjs';
import { SidebarService } from '../../../../../shared/services/sidebar.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent {
  @ViewChild('appSidebar') appSidebar!: SidebarComponent;
  searchQuery: string = '';
  filteredResults: any[] = [];
  sensors: Sensor[] = [];
  isSidebarOpen: boolean = false;

  constructor(
    private geocodingService: GeocodingService,
    private mapService: MapService,
    private sensorService: SensorService,
    private sidebarService: SidebarService
  ) {}

  ngOnInit() {
    this.sensorService.getSensors('piezo').subscribe(
      (sensors) => {
        this.sensors = sensors;
      },
      (error) => {
        console.error('Erreur lors de la récupération des capteurs : ', error);
      }
    );
    this.sidebarService.sidebarStatus$.subscribe((res)=> {
      this.isSidebarOpen = res
    });
  }

  // Fonction pour appeler le service de géocodage et récupérer les suggestions
  searchAddress(event: any) {
    const query = event.query;

    if (query) {
      this.geocodingService.searchAddress(query).pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((addressResults) => {
          if (addressResults && addressResults.length > 0) {
            // Ajouter les résultats de la recherche de capteurs localement filtrés
            const sensorResults = this.filterSensorResults(query);
            const mergedResults = [
              ...addressResults, // Résultats de la géocodification
              ...sensorResults, // Résultats des capteurs filtrés
            ];
            return of(this.removeDuplicates(mergedResults)); // Suppression des doublons
          } else {
            return of(this.filterSensorResults(query)); // Si aucune adresse, ne retourner que les capteurs
          }
        })
      ).subscribe(
        (results) => {
          this.filteredResults = results;
        },
        (error) => {
          console.error('Erreur lors de la recherche : ', error);
        }
      );
    } else {
      this.filteredResults = [];
    }
  }

  filterSensorResults(query: string): any[] {
    const lowerQuery = query.toLowerCase();
    return this.sensors
      .filter(sensor =>
        sensor.identifier.toLowerCase().includes(lowerQuery) ||
        (sensor.altIdentifier && sensor.altIdentifier.toLowerCase().includes(lowerQuery))
      )
      .map(sensor => ({
        display_name: sensor.identifier.toLowerCase().includes(lowerQuery) ? sensor.identifier : sensor.altIdentifier,
        type: 'sensor',
        coords: sensor.coords.geometry.coordinates
      }));
  }



 // Méthode pour recentrer la carte sur les coordonnées sélectionnées
  selectResult(result: any) {
  if (result && result.value && result.value.type === 'sensor' && result.value.coords) {
    const [lon, lat] = result.value.coords;

    if (!isNaN(lat) && !isNaN(lon)) {
      this.mapService.centerMap(lat, lon);
      this.mapService.updateZoomedRefresh(result)
    } else {
      console.error('Les coordonnées du capteur ne sont pas des nombres valides:', lat, lon);
    }
  }
  // Sinon, si le résultat est une adresse géocodée
  else if (result && result.value && result.value.lat && result.value.lon) {
    const lat = parseFloat(result.value.lat);
    const lon = parseFloat(result.value.lon);

    if (!isNaN(lat) && !isNaN(lon)) {
      this.mapService.centerMap(lat, lon);
      this.mapService.updateZoomedRefresh(result)
    } else {
      console.error('Les coordonnées de l\'adresse ne sont pas des nombres valides:', lat, lon);
    }
  } else {
    console.error('Les coordonnées ne sont pas valides dans le résultat:', result);
  }
}
  // Fonction pour supprimer les doublons dans les résultats
  removeDuplicates(results: any[]): any[] {
    return results.filter((result, index, self) =>
      index === self.findIndex((r) => r.display_name === result.display_name)
    );
  }

  openSidebar() {
    this.appSidebar.visible = true;
  }
}
